import { useTranslation } from 'react-i18next';

import { DonorLink } from '@/components/common/links/DonorLink';
import type { AspirationInformationFragment } from '@/types.gql';
import { formatDateString } from '@/utils';

type Props = {
  selectedAspiration: any;
  aspSiteName?: string;
  opuTechnicianId?: string;
  chuteTechnicianId?: string;
  opuTechnicianData?: { id: string; name: string }[];
  aspirationInfo?: AspirationInformationFragment;
  months: number | null;
  lastBredInterval: string;
};

export const AspirationInfoPanel = ({
  selectedAspiration,
  aspSiteName,
  opuTechnicianId,
  chuteTechnicianId,
  opuTechnicianData,
  aspirationInfo,
  months,
  lastBredInterval,
}: Props) => {
  const { t } = useTranslation();

  const opuTechName = opuTechnicianData?.find(
    (i) => i.id === opuTechnicianId,
  )?.name;
  const chuteTechName = opuTechnicianData?.find(
    (i) => i.id === chuteTechnicianId,
  )?.name;

  return (
    <div className="aspiration-form__top-content">
      <div className="aspiration-ivm-info content-panel">
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Date:</span>
          <span className="aspiration-info-value">
            {formatDateString(
              selectedAspiration?.aspirationDate as string,
              'MM/dd/yyyy',
            )}
          </span>
        </div>
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Account:</span>
          <span className="aspiration-info-value">
            {selectedAspiration?.account}
          </span>
        </div>
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Site:</span>
          <span className="aspiration-info-value">{aspSiteName}</span>
        </div>
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Donor:</span>
          <span className="aspiration-info-value">
            {aspirationInfo?.donor && (
              <DonorLink
                donorId={aspirationInfo.donor.id}
                donorName={aspirationInfo.donor.name ?? 'Unnamed Donor'}
              />
            )}
          </span>
        </div>
        {(lastBredInterval || months) && (
          <div className="aspiration-info-item">
            <span className="aspiration-info-label">Donor Info:</span>
            <span className="aspiration-info-value">
              {(lastBredInterval && (
                <span className="aspiration-info-value">
                  {lastBredInterval}
                </span>
              )) ||
                ((months as number) > 0 && (
                  <span className="aspiration-info-value">
                    <>(Age: {months} mos)</>
                  </span>
                ))}
            </span>
          </div>
        )}
        {selectedAspiration?.programName && (
          <div className="aspiration-info-item">
            <span className="aspiration-info-label">
              {t('aspiration.programName')}:
            </span>
            <span className="aspiration-info-value">
              {selectedAspiration.programName}
            </span>
          </div>
        )}
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Schedule:</span>
          <span className="aspiration-info-value">
            {selectedAspiration?.nextSchedule}
          </span>
        </div>
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">OPU tech:</span>
          <span className="aspiration-info-value">{opuTechName}</span>
        </div>
        <div className="aspiration-info-item">
          <span className="aspiration-info-label">Chute tech:</span>
          <span className="aspiration-info-value">{chuteTechName}</span>
        </div>
      </div>
    </div>
  );
};
